function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.248 25.629l14.49-7.735C25.652 17.407 26 16.657 26 16c0-.655-.347-1.405-1.263-1.895L10.248 6.371a3.186 3.186 0 00-2.935-.026C6.453 6.783 6 7.501 6 8.266v15.468c0 .765.453 1.483 1.313 1.921.864.44 1.97.489 2.935-.026zm15.431-5.97c3.095-1.652 3.095-5.666 0-7.318L11.19 4.607C8.02 2.915 4 4.961 4 8.266v15.468c0 3.305 4.02 5.351 7.19 3.659l14.489-7.734z",
  fill: "currentColor"
})));